import React, { useState, useEffect, useMemo } from 'react';
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../../../../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Select, Form, Space, Row, Spin } from 'antd'; // message,, Typography
import styles from './index.module.less';
import FormItem from 'common/FormItem';
//import CustomButton from '@/common/CustomButton';
import { history } from '@/app/history';
import {
  create_admin_unmapped_bus,
  //get_admin_unmapped_bus,
  get_admin_unmapped_project_sites,
  get_BU_Master
} from '../../../../redux/slice';
import { debounce } from 'lodash';

import FormData from 'form-data';
//const { TextArea } = Input;
const { Option } = Select;

function CreateUnmappedBusFlow() {
  TabTitle('Gift Register - Create New Approval Delegator Flow');

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const [formValues, setFormValues] = useState({});

  const [unmappedBusList, setUnmappedBusList] = useState('');
  const [adminProjectSiteList, setAdminProjectSiteList] = useState('');

  const {
    get_all_usersLoading,
    all_users_List,

    //get_all_sbgLoading,
    create_admin_unmapped_busLoading,
    get_admin_unmapped_project_sitesLoading,
    admin_unmapped_project_sitesList,

    //admin_unmapped_bus,
    bu_MasterList
    //adminProjectSites
  } = useSelector((state) => state.admin);
  console.log('all_users_List', all_users_List);

  useEffect(() => {
    const payload = {};
    if (unmappedBusList) payload['search'] = unmappedBusList;
    dispatch(get_BU_Master(payload));
  }, [unmappedBusList]);

  useEffect(() => {
    const payload = {
      page: 1,
      per_page: 1000
    };
    if (adminProjectSiteList) payload['search'] = adminProjectSiteList;
    dispatch(get_admin_unmapped_project_sites(payload));
  }, [adminProjectSiteList, dispatch]);

  const debounceFetcherUnmappedBusList = useMemo(() => {
    const loadOptions = (unmappedBusList) => {
      setUnmappedBusList(unmappedBusList);
    };
    return debounce(loadOptions, 400);
  }, []);

  const debounceFetcheradminProjectSiteList = useMemo(() => {
    const loadOptions = (adminProjectSiteList) => {
      setAdminProjectSiteList(adminProjectSiteList);
    };
    return debounce(loadOptions, 400);
  }, []);

  const handleFormDataOnChange = (slug, value) => {
    console.log('slug,value:', slug, value);

    setFormValues({
      ...formValues,
      [slug]: value
    });
  };

  const onFinish = (values) => {
    console.log(values);
    const formdata = new FormData();
    formdata.append('BuId', formValues?.delegatorId);
    formdata.append('ProjectSiteId', formValues?.delegateId);
    dispatch(create_admin_unmapped_bus(formdata)).then(function (response) {
      if (response?.payload?.success) {
        console.log(response);
        history.push('/unmapped-bus-flow');
      }
    });
  };

  return (
    <CustomLayout>
      <Spin spinning={get_all_usersLoading}>
        <div style={{ marginTop: '50px' }}>
          <Row className={`${styles.row_container_setting}`}>
            <div className={`${styles.gift_container}`}>
              <div className={`${styles.myGift_title_setting}`}>
                Add Unmapped BU with Project site
              </div>
            </div>
          </Row>{' '}
          <div className={`${styles.container}`}>
            <div className={`${styles.cardContainer}`}>
              <Card className={`${styles.cardStyles_Container}`}>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  className={`${styles.formstyles}`}
                >
                  <Card className={`${styles.cardStyles}`}>
                    <div className={`${styles.card_content}`}>
                      <FormItem
                        label={
                          <div className={`${styles.card_title}`}>
                            Please select the BU
                          </div>
                        }
                        name="delegatorId"
                        rules={[
                          {
                            required: true,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Select
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          showSearch
                          allowClear={true}
                          optionFilterProp="children"
                          placeholder="Select BU"
                          onSearch={debounceFetcherUnmappedBusList}
                          onChange={(value) =>
                            handleFormDataOnChange('delegatorId', value)
                          }
                          filterOption={(input, option) => {
                            return option?.children
                              ?.toString()
                              ?.toLowerCase()
                              ?.includes(input?.toLowerCase());
                          }}
                        >
                          {bu_MasterList?.map((item, index) => {
                            return (
                              <Option value={item.id} key={index}>
                                {`${item?.buName}`}
                              </Option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </div>
                  </Card>
                  <Spin spinning={get_admin_unmapped_project_sitesLoading}>
                    <Card className={`${styles.cardStyles}`}>
                      <div className={`${styles.card_content}`}>
                        <FormItem
                          label={
                            <div className={`${styles.card_title}`}>
                              Please select Project Site
                            </div>
                          }
                          name="delegateId"
                          rules={[
                            {
                              required: true,
                              message: 'This is a required field'
                            }
                          ]}
                          className={`${styles.select_styles}`}
                        >
                          <Select
                            className={`${styles.margin_Top}`}
                            style={{ marginBottom: '15px' }}
                            showSearch
                            allowClear={true}
                            optionFilterProp="children"
                            onSearch={debounceFetcheradminProjectSiteList}
                            placeholder="Select Project Site"
                            onChange={(value) =>
                              handleFormDataOnChange('delegateId', value)
                            }
                            filterOption={(input, option) => {
                              return option?.children
                                ?.toString()
                                ?.toLowerCase()
                                ?.includes(input?.toLowerCase());
                            }}
                          >
                            {admin_unmapped_project_sitesList?.map(
                              (item, index) => {
                                return (
                                  <Option value={item.id} key={index}>
                                    {`${item?.name}`}
                                  </Option>
                                );
                              }
                            )}
                          </Select>
                        </FormItem>
                      </div>
                    </Card>
                  </Spin>
                  <div style={{ marginTop: '20px' }}>
                    <FormItem>
                      <Space
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          justifyItems: ' center'
                        }}
                      >
                        <Button
                          loading={create_admin_unmapped_busLoading}
                          className={`${styles.ExceptionalApproval_button}`}
                          htmlType="submit"
                          size="small"
                        >
                          Save
                        </Button>

                        <Button
                          className={`${styles.cancel_rejectModal_button}`}
                          size="small"
                          onClick={() => history.push('/unmapped-bus-flow')}
                        >
                          Cancel
                        </Button>
                      </Space>
                    </FormItem>
                  </div>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </Spin>
    </CustomLayout>
  );
}
export default CreateUnmappedBusFlow;
